import React from "react";

/**
 * Row za lijevu listu (Date / Amount / Status) s multi-select UX-om.
 * Robusno čita amount i status iz različitih naziva polja.
 */
const Row = ({
  item,
  index,
  checked,
  onCheckboxChange,
  onRowClick,
  isActive,
}) => {
  const dateTxt = safeDate(item?.journalentry_date);
  const amountTxt = toMoney(pickAmount(item));
  const statusTxt = pickStatus(item);

  const trStyle = {
    cursor: "pointer",
    background: checked ? "#e6f2ff" : isActive ? "#f7fbff" : "transparent",
  };

  return (
    <tr
      onClick={onRowClick}
      style={trStyle}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          onCheckboxChange(!checked);
        }
      }}
      tabIndex={0}
    >
      <td style={{ padding: "8px" }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onCheckboxChange(e.target.checked)}
          onClick={(e) => e.stopPropagation()}
        />
      </td>
      <td style={{ padding: "8px", minWidth: "80px" }}>{dateTxt}</td>
      <td style={{ padding: "8px", textAlign: "right" }}>{amountTxt}</td>
      <td style={{ padding: "8px" }}>{statusTxt}</td>
    </tr>
  );
};

/* ---- Helpers ---- */

function pickAmount(item) {
  if (!item) return 0;
  const candidates = [
    "amount",
    "total",
    "total_amount",
    "journalentry_total",
    "journalentry_amount",
    "journalentry_Amount",
    "sum",
    "DocAmount",
    "doc_amount",
    "grand_total",
  ];
  for (const k of candidates) {
    if (k in item && item[k] != null && item[k] !== "") {
      const n = Number(item[k]);
      if (isFinite(n)) return n;
      // handle "1.234,56" / "1,234.56"
      const cleaned = String(item[k])
        .replace(/\s+/g, "")
        .replace(/(?<=\d)\.(?=\d{3}(\D|$))/g, "")
        .replace(/,/g, ".");
      const n2 = Number(cleaned);
      if (isFinite(n2)) return n2;
    }
  }
  return 0;
}

function pickStatus(item) {
  if (!item) return "";
  const textCandidates = [
    "status_text",
    "journalentry_status_text",
    "posting_status_text",
    "import_status_text",
    "generate_status_text",
  ];
  for (const k of textCandidates) {
    if (k in item && item[k]) return String(item[k]);
  }
  const generic = [
    "status",
    "journalentry_status",
    "posting_status",
    "import_status",
    "generate_status",
    "qb_status",
  ];
  for (const k of generic) {
    if (!(k in item)) continue;
    const v = item[k];
    if (v == null || v === "") continue;
    if (typeof v === "string" && /[A-Za-z]/.test(v)) return v;
    const code = Number(v);
    if (isFinite(code)) {
      const label =
        {
          0: "New",
          1: "Generated",
          2: "Imported",
          3: "Posted",
          4: "Error",
          5: "Partial",
          6: "Skipped",
        }[code] ?? `Status ${code}`;
      return label;
    }
    return String(v);
  }
  return "";
}

function toMoney(v) {
  const n = Number(v);
  if (!isFinite(n)) return "0.00";
  return n.toFixed(2);
}

function safeDate(d) {
  if (!d) return "";
  try {
    const dt =
      typeof d === "string" && d.length <= 10
        ? new Date(d + "T00:00:00")
        : new Date(d);
    if (isNaN(dt.getTime())) return String(d);
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  } catch {
    return String(d);
  }
}

export default Row;
